import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Button from "../../../common/blocks/button/Button"
import Icon from "../../../common/blocks/icon/Icon"
import * as classNames from "./SearchField.module.scss"

function SearchTypeContractField(props) {

  const [showSuggestion, setShowSuggestion] = useState(false)
  const data = useStaticQuery(
    graphql`
      {
        strapi {
          jobAdCriterias(filters: { type: { eq: "Type de contrat" }}, pagination:{limit:100} ) {
            data {
              attributes {
                key
                value
                type
              }
            }
          }
        }
      }
    `
  )
  const ContractTypeList = data.strapi.jobAdCriterias.data
  const nameChangeHandler = (e) => {
    const userInput = e.currentTarget.value
    props.setName(userInput)
  }
  const addFiltredItems = (e) => {
    if (e.keyCode === 13) {
      props.setFiltredItems([...props.filtredItems, e.target.value])
      e.target.value = ""
      props.setName("")
    }
  }
  const deleteOneFiltre = (arg) => {
    props.setFiltredItems(
      props.filtredItems.filter((el, i) =>
        !isNaN(arg) ? arg !== i : arg !== el
      )
    )
  }

  return (
    <div className={`${classNames.searchField} ${"form-control"}`}>
      <label
        htmlFor="ContractTypeSearch"
        className="sr-only"
      >
        Contrats
      </label>
      <input
        type="search"
        name="ContractTypeSearch"
        id="ContractTypeSearch"
        placeholder="CDI, CDD, Alternance..."
        autoComplete="on"
        onClick={() =>
          showSuggestion ? setShowSuggestion(false) : setShowSuggestion(true)
        }
        onChange={nameChangeHandler}
        onKeyUp={addFiltredItems}
      />
      <Button aspect="unstyled">
        <Icon
          icon="search"
          color="var(--gris)"
        />
      </Button>
      {showSuggestion && (
        <ul className={classNames.ulAutocomplete}>
          {/* {ContractTypeList.map((item, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  ![...props.filtredItems].includes(item.attributes.value)
                    ? props.setFiltredItems([
                        ...props.filtredItems,
                        item.attributes.value,
                      ])
                    : deleteOneFiltre(item.attributes.value)
                  setShowSuggestion(false)
                }}
                onKeyDown={() => {
                  ![...props.filtredItems].includes(item.attributes.value)
                    ? props.setFiltredItems([
                        ...props.filtredItems,
                        item.attributes.value,
                      ])
                    : deleteOneFiltre(item.attributes.value)
                  setShowSuggestion(false)
                }}
              >
                <div className="form-control m-0">
                  <input
                    type="checkbox"
                    id={item.attributes.key + "_" + index}
                    name="checkbox"
                    {...(props.filtredItems.includes(item.attributes.value) && {
                      checked: true,
                    })}
                  />
                  <label htmlFor="checkbox">{item.attributes.value}</label>
                </div>
              </li>
            )
          })} */}
        </ul>
      )}
    </div>
  )
}

export default SearchTypeContractField
